<template>
  <o-form-wrapper
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
    v-model="item"
  >
    <o-form-group v-if="item.id" id="copylink">
      <b-input-group>
        <b-form-input :value="createLink" disabled></b-form-input>
        <b-input-group-append>
          <b-button @click="copyToClipboard">Copy to Clipboard</b-button>
        </b-input-group-append>
      </b-input-group>
    </o-form-group>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="name"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="name"
        v-bind="schema.fields.name"
        v-model="item.name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="letterhead_image"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-file-input
        v-model="item.letterhead_image"
        :show-preview="false"
        :form-state="formState"
        :other-id="item.id"
        other-name="form_template"
        name="letterhead_image"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.letterhead_image"
      ></o-file-input>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="description"
    >
      <o-textarea
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="description"
        v-bind="schema.fields.description"
        v-model="item.description"
      ></o-textarea>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="display_priority"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="display_priority"
        v-bind="schema.fields.display_priority"
        v-model="item.display_priority"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="category"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.category"
        :form-state="formState"
        name="category"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.category"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="versions"
      v-if="item"
    >
      <form-template-version-form-cards
        :form-state="formState"
        :label="schema.fields.versions.label"
        :level="level + 1"
        :server-errors="_se[schema.fields.versions.name]"
        :validators="$v.item.versions"
        v-model="item.versions"
        v-if="item"
      >
      </form-template-version-form-cards>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify.js";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper.vue";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField.vue";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper.vue";
import { default as FormTemplateVersionFormCards } from "../../form_template_version/components/ItemFormCards.vue";
import OTextarea from "../../../../vue-ocom/components/forms/fields/OTextarea.vue";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("FormTemplate"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OTextarea,
    OFormWrapper,
    OWidgetWrapper,
    OTextField,

    FormTemplateVersionFormCards,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.FormTemplate, {}),
  }),
  methods: {
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.createLink)
        .then(() => {})
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    createLink() {
      return `${location.protocol}//${location.host}/static/#/form_entry/create?form_template_id=${this.item.id}`;
    },
  },
  watch: {},
  created() {},
};
</script>
